<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 9 9"
  >
    <g>
      <path
        :fill="color"
        d="M8.393 1.962l-.219-.218-3.293 3.293-3.294-3.293-.219.218 3.294 3.294-3.294 3.293.22.22L4.88 5.474l3.293 3.293.22-.219L5.1 5.256z"
      />
      <path
        fill="none"
        :stroke="color"
        stroke-miterlimit="50"
        d="M8.393 1.962v0l-.219-.218v0L4.881 5.037v0L1.587 1.744v0l-.219.218v0l3.294 3.294v0L1.368 8.549v0l.22.22v0L4.88 5.474v0l3.293 3.293v0l.22-.219v0L5.1 5.256v0z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#2CEBA9',
    },
    size: {
      type: String,
      default: '12',
    },
  },
};
</script>
